import { judgeService, userService } from "../_services";

export default {
  namespaced: true,

  state: {
    judge: null
  },
  getters: {
    JUDGE: state => {
      return state.judge
    },
    JUDGE_FULLNAME: state => {
      if (state.judge) {
        let { lastName, firstName, middleName } = state.judge
        return `${lastName} ${firstName} ${middleName}`
      }
      return ''
    },
  },
  mutations: {
    SET_JUDGE: (state, payload) => {
      state.judge = payload
    },
  },
  actions: {
    GET_JUDGE: ({state, commit }) => {
        if(state.judge == null ){
           return judgeService.getJudge().then(data => {
               commit('SET_JUDGE', data)
               return data
           }).catch(error => {
            if (error.response.status === 500){
              userService.logoutJudge("Пользователь не найден")
              userService.deleteCourt()
            } else
              console.log(error.response)
           })
        } else
           return state.judge
    } 
  }
}